import React, { Component } from 'react';
import { Form, Select,  DatePicker, Button, Spin } from 'antd';
import OperatorAPI from '@/API/operator'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const Option = Select.Option;
const { RangePicker } = DatePicker

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operatorListLoading:false,
      operatorList:[]
    };
  }
  componentDidMount() {
    this.getOperatorList()
  }
  getOperatorList=()=>{
    this.setState({operatorListLoading:true})
    OperatorAPI.getOperatorCodeList().then((res)=>{
      this.setState({operatorList:res,operatorListLoading:false})
    })
  }
  render() {
    const {operatorList,operatorListLoading}=this.state
    const {t,filterChange,search,roleId}=this.props
    return (
      <Form layout="inline">
        {
          (roleId===1||roleId===2)&&(
            <Form.Item label={this.props.t('Carrier Code')}>
              <Spin spinning={operatorListLoading}>
                <Select allowClear style={{width:150}} onChange={(value)=>{filterChange('operator',value)}}>
                  {
                    operatorList.map((operator)=>(<Option value={operator} key={operator}>{operator}</Option>))
                  }
                </Select>
              </Spin>
            </Form.Item>
          )
        }
        { 
          this.props.operator === 'MYDG'
          ?
            this.props.roleId === 9
            ?
            <Form.Item label={t('Type')}>
              <Select allowClear defaultValue={-1} style={{width:250}} onChange={(value)=>{filterChange('notifyType',value)}}>
                <Option value={-1}>{t('All')}</Option>         
                <Option value={2}>{t('Lock Phone')}</Option>
                <Option value={3}>{t('Unlock Phone')}</Option>           
              </Select>
             </Form.Item>
            :
            <Form.Item label={t('Type')}>
              <Select allowClear defaultValue={-1} style={{width:250}} onChange={(value)=>{filterChange('notifyType',value)}}>
                <Option value={-1}>{t('All')}</Option>         
                <Option value={2}>{t('Lock Phone')}</Option>
                <Option value={3}>{t('Unlock Phone')}</Option>
                <Option value={4}>{t('Unbind Contract')}</Option>
              </Select>
            </Form.Item>
        :
        <Form.Item label={t('Type')}>
        <Select allowClear defaultValue={-1} style={{width:250}} onChange={(value)=>{filterChange('notifyType',value)}}>
          <Option value={-1}>{t('All')}</Option>
          <Option value={0}>{t('Payment Notification')}</Option>
          <Option value={1}>{t('Notification Before Locking Phone')}</Option>
          <Option value={2}>{t('Lock Phone')}</Option>
          <Option value={3}>{t('Unlock Phone')}</Option>
          <Option value={4}>{t('Unbind Contract')}</Option>
        </Select>
      </Form.Item>
        }
        
        <Form.Item label={t('Date')}>
          <RangePicker allowClear onChange={(value)=>{filterChange('time',value)}}></RangePicker>
        </Form.Item>
        <Form.Item>
          <Button onClick={search}>{t('Search')}</Button>
        </Form.Item>
      </Form>
    )
  }
}

const mapStateToProps = (state)=>{
  return {
    roleId:state.roleId,
    operator: state.operator
  }
}

export default connect(mapStateToProps)(withTranslation()(Filter));